<template>
    <tr :class="['clickable', { disabled: !entity.active, updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <span v-if="!$_updateActionAllowed" class="lock" :title="'Globální zdroj obsahu. Nelze editovat.' | translate">S</span>
          <input
              type="checkbox"
              :id="entity.id"
              :value="entity.id"
              @click.stop
              @change="onChange"
              :checked="isChecked"
          />
          <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
      <span class="lock" v-if="!$_updateActionAllowed" :title="'Globální zdroj obsahu. Nelze editovat.' | translate" v-translate>Zamčeno</span>
      <td :data-th="'Název zdroje' | translate" class="first_data"><strong>{{ entity.hostname }}</strong></td>
        <td :data-th="'Operátor' | translate" v-if="$_readActionAllowedAllOrOwnAndGlobal">
          <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
        </td>
        <td :data-th="'IP adresa' | translate">{{ entity.ip }}</td>
        <td :data-th="'Virtuální zdroj' | translate">
            <img
					class="is_set"
					src="../../../assets/images/is-set.svg"
					:alt="'Ano' | translate"
					v-if="entity.virtual">
        </td>
      <td :data-th="'Lineární obsah' | translate">
        <template v-for="(item, index) in linearContentProtocols">
                <span>
                  <entity-link :id="item.id" type="protocol">{{ item.name }}</entity-link><span v-if="index < linearContentProtocols.length - 1">, </span>
                </span>
        </template>
      </td>
        <td :data-th="'TimeShift' | translate">
            <template v-for="(item, index) in timeshiftProtocols">
                <span class="dotted">
                  <entity-link :id="item.id" type="protocol">{{ item.name }}
                    <span class="help_popup help_popup--no-width" v-html="timeshiftMinutes(item.number)"></span>
                  </entity-link>
                </span>
                <template v-if="index < timeshiftProtocols.length - 1">,</template>
            </template>
        </td>
        <td :data-th="'Catchup' | translate">
            <template v-for="(item, index) in catchupProtocols">
                <span class="dotted">
                  <entity-link :id="item.id" type="protocol">{{ item.name }}
                    <span class="help_popup help_popup--no-width" v-html="catchupHours(item.number)"></span>
                  </entity-link>
                </span>
                <template v-if="index < catchupProtocols.length - 1">,</template>
            </template>
        </td>
        <td :data-th="'PVR' | translate">
            <template v-for="(item, index) in pvrProtocols">
                <span class="dotted">
                  <entity-link :id="item.id" type="protocol">{{ item.name }}
                    <span class="help_popup help_popup--no-width" v-html="pvrDays(item.number)"></span>
                  </entity-link>
                </span>
                <template v-if="index < pvrProtocols.length - 1">,</template>
            </template>
        </td>
        <td class="no_padding edit">
            <div class="edit_inner">
              <a
                  v-if="!isActiveBool && $_updateActionAllowed"
                  class="btn btn_action btn_grey btn_enable"
                  :title="'Aktivovat' | translate"
                  @click.prevent.stop="emitUpdateEntity({active: true})">
              </a>
              <a
                  v-if="isActiveBool && $_updateActionAllowed"
                  class="btn btn_action btn_grey btn_disable"
                  :title="'Deaktivovat' | translate"
                  @click.prevent.stop="emitUpdateEntity({active: false})">
              </a>
                <a
                    v-if="$_deleteActionAllowed"
						class="btn btn_action btn_delete"
												:title="'Smazat' | translate"
						@click.prevent.stop="emitDeleteEntity"
						v-translate>Smazat
				</a>
            </div>
        </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
		name: "ContentSourceRow",
    components: { EntityLink },
		mixins: [rowActions],
		props: {
			protocolsById: Object
		},
		data() {
			return {
				moduleName: 'contentSources',
				detailPageRouteName: 'contentSourceDetail',
			}
		},
    computed: {
      isActiveBool() {
        return this.entity.active
      },
      linearContentProtocols() {
        return this.mapProtocolIdsToNames(this.entity['linear_content_protocol_ids'])
      },
      timeshiftProtocols() {
        return this.mapNonLinearContentSettingsProtocols('timeshift_protocols')
      },
      catchupProtocols() {
        return this.mapNonLinearContentSettingsProtocols('catchup_protocols')
      },
      pvrProtocols() {
        return this.mapNonLinearContentSettingsProtocols('pvr_protocols')
      },
    },
		methods: {
			timeshiftMinutes(value) {
				return value + '&nbsp;' + this.$gettext('min')
			},
			catchupHours(value) {
				return value + '&nbsp;' + this.$gettext('h')
			},
			pvrDays(value) {
				return value + '&nbsp;' + this.$gettext('dní')
			},
			mapProtocolIdsToNames(ids) {
				return this._.map(ids, function (id) {
					return {
						id: id,
						name: this._.has(this.protocolsById, id) ? this.protocolsById[id]['name'] : '?'
					}
				}.bind(this))
			},
			mapNonLinearContentSettingsProtocols(key) {
				let protocols = []
				if (this.entity['nonlinear_content_protocol_ids'] !== null) {
					this._.forEach(this.entity['nonlinear_content_protocol_ids'][key], function (value, id) {
						let protocolName = '?'
						if (this._.has(this.protocolsById, id)) {
							protocolName = this.protocolsById[id]['name']
						}
						protocols.push({
							id: id,
							name: protocolName,
							number: value
						})
					}.bind(this))
				}
				return protocols
			},
      emitUpdateEntity(params) {
        this.$emit('updateEntity', {'id': this.entity.id, 'params': params})
      },
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/ContentSourceRow.vue